import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../emotion-theme";

export const Message = styled.h2`
  display: block;
  padding: 32px;
  color: ${BASE_COLORS.slightLightGray};
  font-size: ${FONT_SIZES.h2};
  text-align: center;
  width: 100%;
`;
